import * as api from "../Api";

export const getSingleLocationReceipt = () => async (dispatch) => {
  try {
    const { data } = await api.getSingleLocationReceipt();
    dispatch({ type: "SINGLE_LOCATION_RECEIPT", payload: data });
  } catch (error) {}
};
